import { Method_Type as MethodType } from "gen/company/tender/models_pb"

// Tender option types
export const OptionTypes = {
  CHARGE_ACCOUNT: MethodType.CHARGE_ACCOUNT,
  CASH: MethodType.CASH,
  CHECK: MethodType.CHECK,
  CARD: MethodType.CARD,
  WRITE_OFF: MethodType.WRITE_OFF,
  CUSTOM: MethodType.CUSTOM,
  ACH: MethodType.ACH,
  GIFT_CARD: MethodType.GIFT_CARD,
} as const

export type OptionType = (typeof OptionTypes)[keyof typeof OptionTypes]
export type DefaultOptionType =
  | typeof OptionTypes.CHARGE_ACCOUNT
  | typeof OptionTypes.CARD
  | typeof OptionTypes.CASH
  | typeof OptionTypes.CHECK
  | typeof OptionTypes.WRITE_OFF
  | typeof OptionTypes.ACH
  | typeof OptionTypes.GIFT_CARD
